import {autoinject, customAttribute} from 'aurelia-framework';
import {CssAnimator} from 'aurelia-animator-css';

@customAttribute('slide-if')
@autoinject()
export class SlideIfAttribute {

    constructor(private element: Element, animator: CssAnimator) {
    }

    bind() {
        var $ = window["jQuery"];
        if (this["value"]) {
            $(this.element).show();
        } else {
            $(this.element).hide();
        }
    }

    valueChanged(newValue) {
        var $ = window["jQuery"];
        if (newValue) {
            $(this.element).slideDown('fast');
        } else {
            $(this.element).slideUp('fast');
        }
    }

}